import React from "react";

const arshiya_kazi = () => {
  return (
    <div>
      <h1>Arshiya Kazi</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Eligibility criteria for the aptitude test included a CGPA above 7.5 and
        the process was open only for female students.{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <ul>
        <li>
          <strong>Aptitude Test:</strong> 30th August{" "}
        </li>
        <li>
          <strong>Results Announcement:</strong> 10th September{" "}
        </li>
        <li>
          <strong>Interview :</strong> 16th September
        </li>
      </ul>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round had 2 coding questions, one was very easy, and the
        other was a bug-fixing problem where you had to correct the given code.
        There were also some MCQs on C/C++, like predicting the output or
        identifying errors. In addition, there were 15 logical reasoning MCQs.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        <strong>9 students</strong> were shortlisted for the interview round
        after the aptitude test, of which 2 received offers.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        There was enough time between the result declaration and the interview.
        During that period, I fully focused on revising Operating Systems
        concepts, including process scheduling, memory management, and
        synchronization. I also went through some interview questions related to
        OS. Along with that, I revised C programming, OOPs concepts, and my
        projects and prepared for some common HR questions for the interview
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There was only one technical interview round and no separate HR round.
        <br />
        The interview started with a short self-introduction, followed by
        technical questions.
        <br />
        Most questions were based on Operating Systems, including topics like
        virtual memory, cache, TLB and endianness.
        <br />
        Then I was asked C programming questions, mainly on pointers and
        structures, and was also told to write a code in C during the interview.
        <br />
        Towards the end, the interviewer asked a few general questions like “Why
        NVIDIA?” and about my past internship experience.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewer focused a lot on Operating Systems topics like virtual
        memory, cache, and endianness.
        <br />
        They expected me to have good practical knowledge of C programming,
        especially with pointers.
        <br />I was also asked to solve and code a DSA problem in C during the
        interview.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        OS : CodeHelp by Babbar (OS Placement Series), GeeksforGeeks and Medium
        interview questions
        <br />
        C Programming: GeeksforGeeks articles , interview questions
        <br />
        DSA: Striver’s SDE Sheet{" "}
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        To crack coding questions, understand the problem well, plan your logic,
        and keep your basics strong. Work on good projects that help you improve
        your practical understanding.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        There were no questions asked about projects, clubs, or extracurricular
        activities from my resume.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        For NVIDIA, make sure your OS and C basics are strong and practice
        coding DSA problems. Be ready to explain your logic clearly in the
        interview. Use the time before the interview wisely to practice coding,
        brush up on weak areas, and thoroughly review your resume.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The placement process can be stressful, so stay calm and maintain a
        positive mindset. Best of luck!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:kaziag23.comp@coeptech.ac.in">kaziag23.comp@coeptech.ac.in</a>
        <br />
      </p>
    </div>
  );
};

export default arshiya_kazi;
